import React, {
    useEffect, useCallback, useState, useContext, Fragment
} from 'react';
import { Loader, useModal } from '@jutro/components';
import { withRouter } from 'react-router-dom';
import { useAuthentication } from 'gw-digital-auth-react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import _ from 'lodash';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { TranslatorContext } from '@jutro/locale';
import { ClaimService } from 'gw-capability-claim';
import { ServiceRequestService } from 'gw-capability-servicerequest';
import metadata from './FNOLClaimDetailsComponent_AX.metadata.json5';
import styles from './FNOLClaimDetailsComponent_AX.module.scss';
import messages from './FNOLClaimDetailsComponent_AX.messages';
import ConditionsDetailAX from '../ConditionsDetail_AX/ConditionsDetail_AX';
import NagPageAX from '../../pages/NagPage_AX/NagPage_AX';

const checkHasAssitenceCoverage = (lossCause, policy, setHasAssitenceCoverage) => {
    if (!_.isUndefined(policy.coverages)) {
        const coverages = _.get(policy, 'coverages');
        if (lossCause === 'AX_roadside_assistance') {
            if (coverages !== undefined && coverages.length > 0
                && (_.find(coverages, (coverage) => coverage.ax_Code === 'ax_59'
                || coverage.ax_Code === 'ax_5080'
                || coverage.ax_Code === 'ax_SERVAS'))) {
                setHasAssitenceCoverage(true);
            } else {
                setHasAssitenceCoverage(false);
            }
        }
    }
};

const FNOLClaimDetailsComponentAX = (props) => {
    const { authHeader } = useAuthentication();
    const {
        policySelected,
        policySearchCriteriaVM,
        fullPolicy,
        claimReportDTO,
        onRefreshClaimModel,
        hasAssitenceCoverage,
        setHasAssitenceCoverage
    } = props;
    const translator = useContext(TranslatorContext);
    const [isLoading, setLoadingState] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);
    const { refreshData } = useDataRefresh();
    const [vehicleinvolved, setVehicleinvolved] = useState({});
    const [availableLossCauses, updateAvailableLossCauses] = useState([]);
    const [availableAccidents, setAvailableAccidents] = useState([]);
    const [availableStates, setAvailableStates] = useState([]);
    const [availableCities, setAvailableCities] = useState([]);
    const [availableAssistance, setAvaliableAssistance] = useState([]);
    const [isMapVisible, setIsMapVisible] = useState(false);
    const [apiKey, updateApiKey] = useState('');
    const {
        showAlert
    } = useModal();
    const getFullPolicy = useCallback(() => {
        if (!_.isUndefined(fullPolicy.vehicleInvolved)) {
            setVehicleinvolved(fullPolicy.vehicleInvolved);
        }
    }, [fullPolicy]);

    const sortByName = useCallback((list) => {
        return _.sortBy(list, (item) => {
            return item.displayName;
        });
    }, []);

    const sortByID = useCallback((list) => {
        return _.sortBy(list, (item) => {
            console.log("item: ", item)
            return item.id;
        });
    }, []);

    const refreshAssistance = useCallback((option) => {
        _.set(claimReportDTO, 'accidentType', option);
        if (fullPolicy.isProperty) {
            const accidentSelected = claimReportDTO.accidentType.value;
            const allowAssistances = ClaimService.searchAllowAssistanceTypePR(
                fullPolicy.policyNumber,
                accidentSelected.code, authHeader
            );
            allowAssistances.then(
                (result) => {
                    const availableValues = [];
                    result.forEach((item) => {
                        availableValues.push(_.merge({}, item, {
                            id: item.code,
                            displayName: item.name
                        }));
                    });
                    setAvaliableAssistance(sortByName(availableValues));
                },
                (error) => {
                    // eslint-disable-next-line no-console
                    console.error(error);
                }
            );
        }
        onRefreshClaimModel(claimReportDTO);
        refreshData();
    }, [authHeader, claimReportDTO, fullPolicy.isProperty, sortByName,
        onRefreshClaimModel, fullPolicy.policyNumber, refreshData]);

    const onSelectAssistance = useCallback((option) => {
        if (fullPolicy.isProperty) {
            _.set(claimReportDTO, 'assistance', viewModelService.create(
                { code: option },
                'cc',
                'edge.capabilities.claim.fnol.dto.AXAssistanceDTO'
            ).value);
            onRefreshClaimModel(claimReportDTO);
        }
        refreshData();
    }, [claimReportDTO, fullPolicy.isProperty, onRefreshClaimModel, refreshData, viewModelService]);

    const setDefaultValues = useCallback((result) => {
        if (result === 'AX_roadside_assistance' || result === 'AX_assistance') {
            _.set(claimReportDTO, 'phoneNumber', '0000000000');
            _.set(claimReportDTO, 'lossDescription', '0000000000');
            _.set(claimReportDTO, 'lossLocation', '20.6172601,-100.4224806');
        }
    }, [claimReportDTO]);

    const reloadAccidents = useCallback(() => {
        const selected = claimReportDTO.lossCause.value;
        const AllIncidenTypes = viewModelService.productMetadata.get('cc').types.getTypelist('AccidentType').codes;
        if (fullPolicy.isProperty) {
            if (fullPolicy.policyNumber !== undefined && fullPolicy.policyNumber !== '') {
                const allowLossCauseIncident = ClaimService.searchAllowAccidentTypePR(
                    fullPolicy.policyNumber, fullPolicy.producerCode,
                    fullPolicy.policyType, authHeader
                );
                allowLossCauseIncident.then(
                    (result) => {
                        const availableValues = [];

                        _.filter(AllIncidenTypes,
                            (item) => result.includes(item.code)).forEach((item) => {
                            availableValues.push(_.merge({}, item, {
                                id: item.code,
                                displayName: translator({
                                    id: `typekey.AccidentType.${item.code}`,
                                    defaultMessage: 'Not found'
                                })
                            }));
                        });
                        setAvailableAccidents(sortByName(availableValues));
                    },
                    (error) => {
                        // eslint-disable-next-line no-console
                        console.error(error);
                    }
                );
            }
        } else {
            const availableValues = [];
            _.filter(AllIncidenTypes,
                (item) => item.belongsToCategory(selected)).forEach((item) => {
                availableValues.push(_.merge({}, item, {
                    id: item.code,
                    displayName: translator({
                        id: `typekey.AccidentType.${item.code}`,
                        defaultMessage: 'Not found'
                    })
                }));
            });
            setAvailableAccidents(sortByName(availableValues));
        }
        if (!_.isUndefined(claimReportDTO.accidentType.value)) {
            refreshAssistance(claimReportDTO.accidentType.value);
        }
    }, [claimReportDTO.lossCause.value, claimReportDTO.accidentType.value,
        viewModelService.productMetadata, fullPolicy.isProperty, fullPolicy.policyNumber,
        fullPolicy.producerCode, fullPolicy.policyType, authHeader, sortByName, translator,
        refreshAssistance]);

    const reloadLossCauses = useCallback(async () => {
        const result = await ClaimService.retrieveAvailableLossCausesAX(
            policySearchCriteriaVM.origin_AX.value.code,
            authHeader
        );
        const availableCauses = [];
        viewModelService.productMetadata.get('cc').types.getTypelist('LossCause')
            .codes.forEach((typecode) => {
                if (typecode.code === result) {
                    availableCauses.push(_.merge({}, typecode, {
                        id: typecode.code,
                        displayName: translator({
                            id: `typekey.LossCause.${typecode.code}`,
                            defaultMessage: 'Not found'
                        })
                    }));
                }
            });
        checkHasAssitenceCoverage(result, fullPolicy, setHasAssitenceCoverage);
        if (!_.isUndefined(availableCauses[0].code)) {
            _.set(claimReportDTO, 'lossCause', availableCauses[0].code);
        }
        updateAvailableLossCauses(availableCauses);
        setIsMapVisible((result === 'AX_roadside_assistance' || result === 'AX_assistance'));
        setDefaultValues(result);
    }, [authHeader, policySearchCriteriaVM, translator, viewModelService, claimReportDTO,
        fullPolicy, setHasAssitenceCoverage]);

    const loadStates = useCallback(() => {
        const mxStates = [];
        const allStates = viewModelService.productMetadata.get('cc').types.getTypelist('State').codes;

        _.filter(allStates, (item) => item.code.startsWith('MX_')).forEach((typecode) => {
            mxStates.push(_.merge({}, typecode, {
                id: typecode.code,
                displayName: translator({
                    id: `typekey.State.${typecode.code}`,
                    defaultMessage: 'Not found'
                })
            }));
        });
        setAvailableStates(mxStates);
    }, [availableStates]);

    const refreshState = useCallback((state) => {
        _.set(claimReportDTO, 'addressState', state);
        _.set(claimReportDTO, 'addressCity', undefined);
        const cities = [];
        const getAvailableCities = ClaimService.retrieveAvailableCitiesAX(state, authHeader);
        getAvailableCities.then((result) => {
            result.forEach((city) => {
                cities.push(_.merge({}, city, {
                    id: city.name,
                    defaultMessage: 'Not found'
                }));
            });
            setAvailableCities(sortByID(cities));
        });
    }, [claimReportDTO, availableCities, refreshData]);

    const setApiKey = useCallback(() => {
        ServiceRequestService.getConfigProviderByName_AX('HeatMapCredential',
            authHeader).then((key) => {
            updateApiKey(key);
        }).catch(() => {
            showAlert({
                status: 'error',
                icon: 'mi-error',
                title: translator(messages.error),
                message: translator(messages.errorMessage)
            });
        });
    }, [apiKey]);

    useEffect(() => {
        setLoadingState(true);
        getFullPolicy();
        loadStates();
        setApiKey();
        reloadLossCauses()
            .then(() => {
                reloadAccidents();
            // eslint-disable-next-line no-console
            }).catch(() => {
                showAlert({
                    status: 'error',
                    icon: 'mi-error',
                    title: translator(messages.error),
                    message: translator(messages.errorMessage)
                });
            })
            .finally(() => {
                setLoadingState(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderInsuredAmount = useCallback((rowData, rowIndex) => {
        const amount = _.get(rowData, 'incidentLimit');
        return (
            <CurrencyField
                id={`amount_${rowIndex}`}
                value={amount}
                readOnly
            />
        );
    }, []);

    const onLocationChange = useCallback((location) => {
        _.set(claimReportDTO, 'lossLocation', `${location.lat.toString()},${location.lng.toString()}`);
        refreshData();
    }, [claimReportDTO, refreshData]);

    const onPlaceChangedAX = useCallback((location) => {
        _.set(claimReportDTO, 'lossLocation', `${location.lat()},${location.lng()}`);
        refreshData();
    }, [refreshData, claimReportDTO]);

    const claimReportModelChanged = useCallback((newModel) => {
        onRefreshClaimModel(newModel);
        refreshData();
    }, [onRefreshClaimModel, refreshData]);

    const renderDeductible = useCallback((rowData) => {
        const deductible = _.get(rowData, 'deductible');
        return !_.isUndefined(deductible) ? deductible.amount : '0';
    }, []);

    const renderExpanderContentFn = useCallback((rowData) => {
        return <ConditionsDetailAX data={rowData} />;
    }, []);

    const renderNag = useCallback(() => {
        const lossCause = _.get(claimReportDTO, 'lossCause.value.code');
        if (lossCause === 'glassbreakage') {
            return (
                <>
                    <hr />
                    <NagPageAX selectedPolicy={fullPolicy} claimReportDTO={claimReportDTO} />
                </>
            );
        }
        return <Fragment />;
    }, [claimReportDTO, fullPolicy]);

    if (!fullPolicy.isProperty) {
        Object.assign(fullPolicy, vehicleinvolved);
    }

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const overrides = {
        coverageTable: {
            data: _.get(fullPolicy, 'coverages')
        },
        insuredAmountId: {
            renderCell: renderInsuredAmount
        },
        deductibleId: {
            renderCell: renderDeductible
        },
        vehicleDataTab: {
            visible: !fullPolicy.isProperty
        },
        assistsTable: {
            data: _.get(fullPolicy, 'assistances')
        },
        specialConditionsDataTable: {
            data: _.get(fullPolicy, 'specialConditions'),
            renderExpanderContent: renderExpanderContentFn
        },
        lossCause: {
            availableValues: availableLossCauses,
            disabled: availableLossCauses.length < 2
        },
        accidentType: {
            availableValues: availableAccidents
        },
        stateDropdown: {
            availableValues: availableStates
        },
        cityDropdown: {
            availableValues: availableCities
        },
        assistanceType: {
            availableValues: availableAssistance,
            visible: (!_.isUndefined(fullPolicy.isProperty) && fullPolicy.isProperty)
        },
        emptySpace2: {
            visible: !(!_.isUndefined(fullPolicy.isProperty) && fullPolicy.isProperty)
        },
        noAssistanceCoverageNotification: {
            visible: hasAssitenceCoverage !== undefined && !hasAssitenceCoverage
        },
        serviceAddressLatLng: {
            content: `${_.get(claimReportDTO, 'lossLocation').value}`
        },
        isRoadField: {
            visible: !fullPolicy.isProperty
        },
        cityStateLayout: {
            visible: !isMapVisible,
        },
        mapGridLayout: {
            visible: isMapVisible,
        },
        mapArea: {
            value: _.get(claimReportDTO, 'lossLocation').value,
            googleMapsApiKey: apiKey,
        },
        addressLookup: {
            className: styles.addresslookup__width
        }
        
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            refreshAssistance: refreshAssistance,
            onSelectAssistance: onSelectAssistance,
            onPlaceChangedAX: onPlaceChangedAX,
            onLocationChange: onLocationChange,
            refreshState: refreshState
        }
    };

    return (
        < >
            <ViewModelForm
                uiProps={metadata.claimDetailsComponentContent}
                model={claimReportDTO}
                overrideProps={overrides}
                onModelChange={claimReportModelChanged}
                callbackMap={resolvers.resolveCallbackMap}
            />
            {renderNag()}
            <hr />
            <ViewModelForm
                uiProps={metadata.policyDetailsComponentContent}
                model={fullPolicy}
                overrideProps={overrides}
            />
        </>
    );
};

export default withRouter(FNOLClaimDetailsComponentAX);
